// =====================================================
// GUEST FORM VALIDATION
// Stage 2: Participants & Pricing
// Validation logic for guest registration form
// =====================================================

import type { GuestFormData } from '../components/GuestRegistrationForm';

/**
 * Validate guest form data
 */
export function validateGuestForm(data: GuestFormData): {
  valid: boolean;
  errors: Partial<Record<keyof GuestFormData, string>>;
} {
  const errors: Partial<Record<keyof GuestFormData, string>> = {};

  // Full name required
  if (!data.full_name || data.full_name.trim().length < 3) {
    errors.full_name = 'El nombre completo debe tener al menos 3 caracteres';
  }

  // Email validation (if provided)
  if (data.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      errors.email = 'Email inválido';
    }
  }

  // Age validation (if provided)
  if (data.age !== undefined) {
    if (data.age < 1 || data.age > 120) {
      errors.age = 'La edad debe estar entre 1 y 120 años';
    }
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors,
  };
}
